<span (click)="emitToggle()">{{text}}</span>
<input type="checkbox"
       [checked]="checked"
       class="switch"/>
<label (click)="emitToggle()"></label>
